export const isNonNullable = <T>(value: T): value is NonNullable<T> =>
  value !== null && value !== undefined;

export const isRecord = (val: unknown): val is Record<string, unknown> =>
  isNonNullable(val) && typeof val === 'object';
export const isString = (val: unknown): val is string =>
  typeof val === 'string';
export const isUndefined = (val: unknown): val is undefined =>
  typeof val === 'undefined';
export const isLiteral = <T extends string>(val: unknown, lit: T): val is T =>
  val === lit;
export const isNumber = (val: unknown): val is number =>
  typeof val === 'number';
export const isList = (val: unknown): val is unknown[] => Array.isArray(val);
